import { useProfilePicture } from '@/src/hooks/useProfilePicture.hook'
import { useSessionStore } from '@/src/hooks/use_session_store'
import { Avatar, Flex, Image, Text } from '@chakra-ui/react'
import { FlexRow } from '@components'
import type { FC } from 'react'

export const UserMessage: FC<{ text: string; bgColor?: string }> = ({ text, bgColor }) => {
  const { user } = useSessionStore()
  const userFullName = user?.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : ''
  const { data: profilePicUrl = '' } = useProfilePicture()

  return (
    <FlexRow gap='6px' ml='auto'>
      <Flex borderRadius={'2px'} padding={'10px'} bg={bgColor ?? 'white'}>
        <Text color={'#0A1D3D'} fontSize={'13px'}>
          {text}
        </Text>
      </Flex>
      <Flex mt='auto'>
        {profilePicUrl !== '' ? (
          <Image boxSize='100px' borderRadius='full' objectFit='cover' src={profilePicUrl} w='20px' h='20px' />
        ) : (
          <Avatar size='2xs' name={userFullName} />
        )}
      </Flex>
    </FlexRow>
  )
}
